import { render, staticRenderFns } from "./WeddingDemo2View.vue?vue&type=template&id=f9b773a8&scoped=true&"
import script from "./WeddingDemo2View.vue?vue&type=script&lang=js&"
export * from "./WeddingDemo2View.vue?vue&type=script&lang=js&"
import style0 from "./WeddingDemo2View.vue?vue&type=style&index=0&id=f9b773a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b773a8",
  null
  
)

export default component.exports